<div [class]="businessSettingsStateClass">

  @if (isViewMode) {
    <div class="business-settings-header" data-cy="business-settings-header">
      @if (showEditActionButton) {
        <button (click)="toggleToEditMode()"
          [class.disable]="isEditActionAvailable"
          class="btn-secondary"
          data-cy="business-settings-edit-button"
          type="button">Edit
        </button>
      }
      @if (this.userService.hasPermissions([Permission.ADMIN_BUSINESS_SETTINGS_VIEW])) {
        <button type="button" class="btn-text-link text-button-with-pipes"
          data-cy="business-settings-download-configuration-button"
          (click)="exportConfiguration()">
          <span class="text-button-pipe first"></span>
          <span class="iwp-icon-gen_download"></span>
          <span class="text text-button-label">Export configuration</span>
          <span class="text-button-pipe last"></span>
        </button>
      }
      <div class="header-footer-right-section">
        @if (showApplyActionButton) {
          <button (click)="toggleToShowBusinessSettingsApplyModal(contextData)"
            [class.disable]="isSubmitActionAvailable"
            [disabled]="!canApply"
            class="btn-primary"
            data-cy="business-settings-header-apply-button"
            type="button">
            <app-tooltip [disable]="canApply"
              [dynamic]="false"
              message="You can't apply a draft version with unfinished paths">Apply
            </app-tooltip>
          </button>
        }
        @if (showReplicateActionButton) {
          <button (click)="toggleToShowBusinessSettingsReplicateModal(contextData)"
            [class.disable]="isReplicateActionAvailable"
            type="button"
            data-cy="business-settings-header-replicate-button"
            class="btn-primary action-button">
            <span data-cy="business-settings-header-replicate-button-text">Replicate as draft</span>
          </button>
        }
      </div>
    </div>
  }

  <div class="business-settings-title">
    <div [attr.class]="titleStatusClass">
      <span data-cy="business-settings-title-display-mode">{{contextData?.displayMode}} MODE</span>
    </div>
    <div class="business-settings-title-activation-date-version"
      [ngClass]="$safeNavigationMigration(contextData?.status.code)"
    data-cy="business-settings-title-activation-date-version">{{contextData?.title}}</div>

    <div class="business-settings-title-status {{contextData?.titleStatus}}"
    data-cy="business-settings-title-status">{{contextData?.titleStatus}}</div>
  </div>

  <div class="business-settings-container">
    <app-entity-tree [entityTree]="entityList"
      [entityTreeData]="entityListData"
      [configurationTreeNode]="rootTreeNode"
      [displayMode]="contextData.displayMode"
      (updatedTree)="updateBusinessSettingsDisplay($event)"
      (updatedPaths)="updatedPathsHandler($event)"
      [setTreePath]="setTreePath"
    [editEntityElement]="editEntityElement"></app-entity-tree>
  </div>

  @if (showSettingFooter) {
    <div class="business-settings-footer">
      <app-upload-configuration (loadEvent)="onUploadConfiguration($event)"
        data-cy=business-settings-upload-configuration
        baseDataCy="business-settings-upload-configuration"
      buttonText="Upload configuration"></app-upload-configuration>
      <div class="header-footer-right-section">
        <button type="button" class="btn-text-link" (click)="discard()" data-cy="business-settings-cancel-button">
          <span class="text">Discard</span>
        </button>
        <button type="button" class="btn-primary" (click)="save()" data-cy="business-settings-save-button"
          [disabled]="!treeWasChanged">Save
        </button>
      </div>
    </div>
  }

</div>
